export default {
  write: (name, value, state = {}) => {
    let oldUrl = window.location.href,
      url = "",
      regExp = new RegExp("([&?])" + name + '=[^&]+')

    if (window.location.search.length > 0) {
      if (regExp.test(window.location.search)) {
        url = window.location.href.replace(regExp, "$1" + name + "=" + encodeURIComponent(value))
      } else {
        url = window.location.href + "&" + name + "=" + encodeURIComponent(value)
      }
    } else {
      url = window.location.href + "?" + name + "=" + encodeURIComponent(value)
    }
    if (oldUrl !== url)
      window.history.pushState(state, "", url)
    return true
  },

  remove: (name, state = {}) => {
    let url = "",
      regExp = null

    if (window.location.search.length > 0) {
      regExp = new RegExp("([&?])" + name + '=[^&]+&?')
      url = window.location.href.replace(regExp, "$1")
      if (url !== window.location.href) {
        window.history.pushState(state, "", url)
        return true
      }
    }

    return false
  },

  read: (name) => {
    let regExp = null,
      matches = null

    if (window.location.search.length > 0) {
      regExp = new RegExp("[?&]" + name + "=" + "([^&]+)")
      matches = window.location.search.match(regExp)
      if (matches)
        return decodeURIComponent(matches[1])
    }

    return false
  },
}
